import { render, staticRenderFns } from "./ContactEditExtraFields.vue?vue&type=template&id=3d04de0b"
import script from "./ContactEditExtraFields.vue?vue&type=script&lang=ts"
export * from "./ContactEditExtraFields.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports